import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06d8ff06"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pb-8" }
const _hoisted_2 = { class: "custom-gradient text-center text-2xl not-italic font-semibold md:pb-2 sm:pb-2 md:mb-6 sm:mb-2 mt-16" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-center mt-8 mb-6 sm:text-sm" }, null, -1))
const _hoisted_6 = { class: "paymentBoxLeft md:p-6 sm:pt-4 sm:mb-6 relative paymentWrapper" }
const _hoisted_7 = { class: "paymentBoxRight md:p-6 sm:pt-4 sm:mb-6 relative" }
const _hoisted_8 = {
  key: 0,
  class: "mb-6 p-2 br16 overflow-x-auto"
}
const _hoisted_9 = { class: "pr-6 mb-5" }
const _hoisted_10 = { class: "capitalize" }
const _hoisted_11 = { class: "flex" }
const _hoisted_12 = ["onUpdate:modelValue", "disabled"]
const _hoisted_13 = ["onUpdate:modelValue", "disabled"]
const _hoisted_14 = { class: "capitalize" }
const _hoisted_15 = { class: "flex" }
const _hoisted_16 = {
  key: 1,
  class: "mb-6 p-2 br16 overflow-x-auto"
}
const _hoisted_17 = { class: "pr-6 mb-5" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "capitalize" }
const _hoisted_20 = { class: "flex" }
const _hoisted_21 = { class: "flex scoreBox br8 noBorderB" }
const _hoisted_22 = ["max", "onUpdate:modelValue", "disabled"]
const _hoisted_23 = { class: "flex scoreBox br8 noBorderT" }
const _hoisted_24 = ["max", "onUpdate:modelValue", "disabled"]
const _hoisted_25 = { class: "flex" }
const _hoisted_26 = { class: "capitalize" }
const _hoisted_27 = {
  key: 0,
  id: "savingResults",
  class: "scoreButtons pb-6"
}
const _hoisted_28 = ["value", "disabled"]
const _hoisted_29 = ["value"]
const _hoisted_30 = {
  key: 2,
  class: "h-24"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BookingDetail = _resolveComponent("BookingDetail")!
  const _component_AddPlayers = _resolveComponent("AddPlayers")!
  const _directive_disable_on_click = _resolveDirective("disable-on-click")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.booking.type?.code == _ctx.bookingType.MATCH)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t("match_details")), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.$t("booking_details")), 1))
      ]),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        (_ctx.booking.id !== undefined)
          ? (_openBlock(), _createBlock(_component_BookingDetail, {
              key: 0,
              booking: _ctx.booking,
              showImage: false,
              showChat: _ctx.user.id !== 0,
              showOpenFacility: false,
              showResourceName: true,
              class: "paymentBoxLeft p-6 pt-8 md:mr-6"
            }, null, 8, ["booking", "showChat"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          (_ctx.booking.id !== undefined)
            ? (_openBlock(), _createBlock(_component_AddPlayers, {
                key: 0,
                showTitle: false,
                bookingData: _ctx.booking,
                mode: _ctx.mode.RESULTS,
                active: _ctx.movePlayers,
                onSetUpCompleted: _ctx.openPaymentMethodHandler
              }, null, 8, ["bookingData", "mode", "active", "onSetUpCompleted"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["flex flex-col scoreScope mb-6 p-2 br16 overflow-x-auto", { 'flex-col-reverse': _ctx.showEdited, '': true }])
      }, [
        (_ctx.showEdited || (!_ctx.showEditResults || _ctx.secondEdition) && _ctx.showMainResults && !_ctx.isSoccer())
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", null, _toDisplayString(_ctx.$t("score")), 1)
              ]),
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.getTeamNames(_ctx.team.TEAM1)), 1),
              _createElementVNode("div", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.maxSportSets, (i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: i,
                    class: "items-center w-full scoreResult text-xs text-center text-gray-400"
                  }, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("set")) + " " + _toDisplayString(i), 1)
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", {
                class: "flex scoreBox br8 noBorderB",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (
            _ctx.validNumberPlayers && _ctx.allResults.length < 1
              ? (_ctx.savingResults = true)
              : (_ctx.savingResults = false)
          ))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.maxSportSets, (i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "flex items-center borderl justify-center w-full scoreResult",
                    key: i
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": ($event: any) => ((_ctx.resultsTeam1[i - 1]) = $event),
                      class: "bg-transparent",
                      disabled: 
                !_ctx.validNumberPlayers || _ctx.allResults.length > 1 || !_ctx.userIsPlayer
              
                    }, null, 8, _hoisted_12), [
                      [_vModelText, _ctx.resultsTeam1[i - 1]]
                    ])
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", {
                class: "flex scoreBox br8 noBorderT",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (
            _ctx.validNumberPlayers && _ctx.allResults.length < 1
              ? (_ctx.savingResults = true)
              : (_ctx.savingResults = false)
          ))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.maxSportSets, (i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: i,
                    class: "flex items-center borderl justify-center w-full scoreResult"
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": ($event: any) => ((_ctx.resultsTeam2[i - 1]) = $event),
                      class: "bg-transparent",
                      disabled: 
                !_ctx.validNumberPlayers || _ctx.allResults.length > 1 || !_ctx.userIsPlayer
              
                    }, null, 8, _hoisted_13), [
                      [_vModelText, _ctx.resultsTeam2[i - 1]]
                    ])
                  ]))
                }), 128))
              ]),
              _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.getTeamNames(_ctx.team.TEAM2)), 1),
              _createElementVNode("div", _hoisted_15, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.maxSportSets, (i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: i,
                    class: "items-center w-full scoreResult text-xs text-center text-gray-400"
                  }, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("set")) + " " + _toDisplayString(i), 1)
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.showEdited || _ctx.showEditResults)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t("score")) + " ", 1),
                  (_ctx.showEdited || _ctx.secondEdition)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_18, "(" + _toDisplayString(_ctx.$t("edited")) + ")", 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.getTeamNames(_ctx.team.TEAM1)), 1),
              _createElementVNode("div", _hoisted_20, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.maxSportSets, (i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: i,
                    class: "items-center w-full scoreResult text-xs text-center text-gray-400"
                  }, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("set")) + " " + _toDisplayString(i), 1)
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_21, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.maxSportSets, (i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: i,
                    class: "flex items-center borderl justify-center w-full scoreResult"
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      min: "0",
                      max: _ctx.maxSetPoints,
                      "onUpdate:modelValue": ($event: any) => ((_ctx.editedResultsTeam1[i - 1]) = $event),
                      placeholder: "0",
                      class: "bg-transparent",
                      disabled: _ctx.allResults.length > 1 || !_ctx.userIsPlayer,
                      onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.checkArrays && _ctx.checkArrays(...args)))
                    }, null, 40, _hoisted_22), [
                      [_vModelText, _ctx.editedResultsTeam1[i - 1]]
                    ])
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_23, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.maxSportSets, (i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: i,
                    class: "flex items-center borderl justify-center w-full scoreResult"
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      min: "0",
                      max: _ctx.maxSetPoints,
                      "onUpdate:modelValue": ($event: any) => ((_ctx.editedResultsTeam2[i - 1]) = $event),
                      placeholder: "0",
                      class: "bg-transparent",
                      disabled: _ctx.allResults.length > 1 || !_ctx.userIsPlayer,
                      onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.checkArrays && _ctx.checkArrays(...args)))
                    }, null, 40, _hoisted_24), [
                      [_vModelText, _ctx.editedResultsTeam2[i - 1]]
                    ])
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_25, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.maxSportSets, (i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: i,
                    class: "items-center w-full scoreResult text-xs text-center text-gray-400"
                  }, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("set")) + " " + _toDisplayString(i), 1)
                  ]))
                }), 128))
              ]),
              _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.getTeamNames(_ctx.team.TEAM2)), 1)
            ]))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    (!_ctx.showEdited && _ctx.savingResults)
      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
          _withDirectives(_createElementVNode("input", {
            class: _normalizeClass(["search-btn mb-4", { 'button-disabled': _ctx.hasErrors, '': true }]),
            type: "button",
            value: _ctx.$t('save'),
            disabled: _ctx.hasErrors,
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.saveResults()))
          }, null, 10, _hoisted_28), [
            [_directive_disable_on_click, void 0, "match-results"]
          ]),
          (_ctx.secondEdition)
            ? (_openBlock(), _createElementBlock("input", {
                key: 0,
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.cancelSaveResults())),
                class: "paymentOption cursor-pointer flex items-center p-6 justify-center",
                type: "button",
                value: _ctx.$t('cancel')
              }, null, 8, _hoisted_29))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.allResults.length < 2 && !_ctx.savingResults && _ctx.userIsPlayer)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          onClick: _cache[6] || (_cache[6] = ($event: any) => {
      _ctx.showEditResults = true;
      _ctx.savingResults = true;
    }),
          class: "flex justify-center items-center custom-gradient cursor-pointer pb-8"
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("click_here_to_change_it")), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.isIos)
      ? (_openBlock(), _createElementBlock("div", _hoisted_30))
      : _createCommentVNode("", true)
  ], 64))
}